import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import * as api from "../api";

function MesAnnonces() {
  const { user } = useAuth();
  const [myAnnonces, setMyAnnonces]   = useState([]);
  const [planInfo, setPlanInfo]       = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [notification, setNotification]  = useState(null);
  const navigate = useNavigate();

  const chargerAnnonces = () => {
    api.getMesAnnonces()
      .then(res => {
        // L'API retourne maintenant { annonces: [], plan_info: {} }
        const data = res.data;
        if (Array.isArray(data)) {
          // Ancien format (sécurité)
          setMyAnnonces(data);
        } else {
          setMyAnnonces(data.annonces || []);
          setPlanInfo(data.plan_info || null);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (!user || (user.role !== "exposant" && user.role !== "admin")) {
      navigate("/connexion");
      return;
    }
    chargerAnnonces();
  }, [user, navigate]);

  const showNotif = (msg) => {
    setNotification(msg);
    setTimeout(() => setNotification(null), 3000);
  };

  const handleDelete = async (id) => {
    try {
      await api.deleteAnnonce(id);
      setConfirmDelete(null);
      showNotif("Annonce supprimée avec succès");
      setMyAnnonces(prev => prev.filter(a => a.id !== id));
    } catch (err) {
      showNotif("Erreur lors de la suppression");
    }
  };

  const handleToggle = async (id) => {
    try {
      await api.toggleStatut(id);
      showNotif("Statut mis à jour");
      chargerAnnonces();
    } catch (err) {
      showNotif("Erreur lors de la mise à jour");
    }
  };

  if (!user) return null;

  // Couleur selon plan
  const planCouleurs = {
    gratuit:            { bg: "#f3f4f6", color: "#6b7280", label: "FREE" },
    premium_starter:    { bg: "#f0fdfa", color: "#0d9488", label: "Premium Starter" },
    premium_business:   { bg: "#eff6ff", color: "#2563eb", label: "Premium Business" },
    premium_enterprise: { bg: "#f5f3ff", color: "#7c3aed", label: "Enterprise" },
  };
  const planStyle = planCouleurs[planInfo?.plan] || planCouleurs["gratuit"];

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />

      {notification && (
        <div style={{ position: "fixed", top: "20px", right: "20px", zIndex: 9999, backgroundColor: "#0d9488", color: "white", padding: "14px 22px", borderRadius: "10px", boxShadow: "0 4px 20px rgba(0,0,0,0.2)", fontSize: "14px", fontWeight: "600" }}>
          ✓ {notification}
        </div>
      )}

      {confirmDelete && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ backgroundColor: "white", borderRadius: "16px", padding: "30px", maxWidth: "380px", width: "100%", textAlign: "center" }}>
            <div style={{ width: "56px", height: "56px", borderRadius: "50%", backgroundColor: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
              </svg>
            </div>
            <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#1f2937", marginBottom: "8px" }}>Supprimer cette annonce ?</h3>
            <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "24px" }}>Cette action est irréversible.</p>
            <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
              <button onClick={() => setConfirmDelete(null)} style={{ padding: "10px 22px", border: "1px solid #e5e7eb", borderRadius: "8px", backgroundColor: "white", cursor: "pointer", fontSize: "14px" }}>Annuler</button>
              <button onClick={() => handleDelete(confirmDelete)} style={{ padding: "10px 22px", border: "none", borderRadius: "8px", backgroundColor: "#dc2626", color: "white", cursor: "pointer", fontSize: "14px", fontWeight: "600" }}>Supprimer</button>
            </div>
          </div>
        </div>
      )}

      <div className="mes-annonces-page">
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>

          {/* En-tête */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px", flexWrap: "wrap", gap: "12px" }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "6px" }}>
                <Link to="/mon-espace" style={{ color: "#6b7280", fontSize: "14px", textDecoration: "none" }}>← Mon espace</Link>
              </div>
              <h1 style={{ fontSize: "26px", fontWeight: "700", color: "#1f2937" }}>Mes annonces</h1>
              <p style={{ fontSize: "14px", color: "#6b7280" }}>{myAnnonces.length} annonce{myAnnonces.length > 1 ? "s" : ""}</p>
            </div>
            <Link to="/ajouter-annonce" style={{ display: "flex", alignItems: "center", gap: "8px", backgroundColor: "#0d9488", color: "white", padding: "12px 22px", borderRadius: "10px", textDecoration: "none", fontSize: "14px", fontWeight: "600" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              Nouvelle annonce
            </Link>
          </div>

          {/* Bandeau plan avec jauge */}
          {planInfo && (
            <div style={{ backgroundColor: planStyle.bg, border: `1px solid ${planStyle.color}33`, borderRadius: "12px", padding: "16px 20px", marginBottom: "24px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ background: planStyle.color, color: "white", fontSize: "11px", fontWeight: "700", padding: "3px 10px", borderRadius: "20px" }}>
                  {planStyle.label}
                </span>
                <span style={{ fontSize: "14px", color: "#374151" }}>
                  <strong style={{ color: planStyle.color }}>{planInfo.annonces_utilisees}</strong>
                  {" / "}
                  <strong>{planInfo.max_annonces === 999999 ? "∞" : planInfo.max_annonces}</strong>
                  {" annonces utilisées"}
                </span>
                {planInfo.photos_illimitees && (
                  <span style={{ fontSize: "12px", color: "#6b7280" }}>· Photos illimitées</span>
                )}
              </div>
              {/* Jauge */}
              <div style={{ minWidth: "180px", flex: "0 0 180px" }}>
                <div style={{ height: "6px", background: "#e5e7eb", borderRadius: "6px", overflow: "hidden" }}>
                  <div style={{
                    height: "100%",
                    borderRadius: "6px",
                    backgroundColor: planInfo.max_annonces === 999999
                      ? planStyle.color
                      : planInfo.annonces_utilisees / planInfo.max_annonces >= 0.9
                        ? "#ef4444"
                        : planStyle.color,
                    width: planInfo.max_annonces === 999999
                      ? "30%"
                      : `${Math.min(100, (planInfo.annonces_utilisees / planInfo.max_annonces) * 100)}%`,
                    transition: "width 0.3s"
                  }} />
                </div>
                <p style={{ fontSize: "11px", color: "#9ca3af", marginTop: "4px", textAlign: "right" }}>
                  {planInfo.max_annonces === 999999
                    ? "Illimité"
                    : `${planInfo.annonces_restantes} restante${planInfo.annonces_restantes > 1 ? "s" : ""}`}
                </p>
              </div>
              {planInfo.annonces_restantes === 0 && planInfo.max_annonces !== 999999 && (
                <Link to="/abonnement" style={{ fontSize: "12px", fontWeight: "600", color: "white", background: "#ef4444", padding: "5px 12px", borderRadius: "8px", textDecoration: "none" }}>
                  Upgrader mon plan →
                </Link>
              )}
            </div>
          )}

          {/* Stats */}
          <div className="mes-annonces-stats" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px", marginBottom: "30px" }}>
            {[
              { label: "Total", value: myAnnonces.length, color: "#6366f1" },
              { label: "Actives", value: myAnnonces.filter(a => a.statut === "active").length, color: "#0d9488" },
              { label: "En attente", value: myAnnonces.filter(a => a.statut !== "active" && a.statut !== "suspendue").length, color: "#f59e0b" }
            ].map(stat => (
              <div key={stat.label} style={{ backgroundColor: "white", borderRadius: "12px", padding: "18px 22px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", display: "flex", alignItems: "center", gap: "14px" }}>
                <div style={{ fontSize: "32px", fontWeight: "700", color: stat.color }}>{stat.value}</div>
                <div style={{ fontSize: "14px", color: "#6b7280", fontWeight: "500" }}>{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Liste annonces */}
          {myAnnonces.length > 0 ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
              {myAnnonces.map(annonce => (
                <div key={annonce.id} style={{ backgroundColor: "white", borderRadius: "14px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", border: annonce.statut === "suspendue" ? "1px solid #fecaca" : "1px solid #f3f4f6", overflow: "hidden" }}>
                  <div className="mes-annonces-card-body">
                    <img
                      src={annonce.image || "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=200"}
                      alt={annonce.nom}
                      style={{ width: "90px", height: "68px", objectFit: "cover", borderRadius: "10px", flexShrink: 0 }}
                    />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" }}>
                        <div style={{ minWidth: 0 }}>
                          <h3 style={{ fontSize: "15px", fontWeight: "700", color: "#1f2937", marginBottom: "4px" }}>{annonce.nom}</h3>
                          <p style={{ fontSize: "13px", color: "#6b7280", marginBottom: "6px" }}>{annonce.description}</p>
                          <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                            <span style={{ padding: "2px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "600", backgroundColor: "#f0fdfa", color: "#0d9488" }}>
                              {annonce.categorie}
                            </span>
                            <span style={{ padding: "2px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "600",
                              backgroundColor: annonce.statut === "active" ? "#f0fdfa" : annonce.statut === "suspendue" ? "#fef2f2" : "#fffbeb",
                              color: annonce.statut === "active" ? "#059669" : annonce.statut === "suspendue" ? "#dc2626" : "#f59e0b"
                            }}>
                              {annonce.statut === "active" ? "Active" : annonce.statut === "suspendue" ? "Suspendue" : annonce.statut || "En attente"}
                            </span>
                          </div>
                        </div>
                        <div className="mes-annonces-card-btns">
                          <Link to={`/annonce/${annonce.id}`} style={{ padding: "7px 14px", backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "7px", textDecoration: "none", color: "#374151", fontSize: "13px", fontWeight: "500" }}>Voir</Link>
                          <Link to={`/modifier-annonce/${annonce.id}`} style={{ padding: "7px 14px", backgroundColor: "#f0fdfa", border: "1px solid #0d9488", borderRadius: "7px", textDecoration: "none", color: "#0d9488", fontSize: "13px", fontWeight: "600" }}>Modifier</Link>
                          <button onClick={() => handleToggle(annonce.id)} style={{ padding: "7px 14px", backgroundColor: annonce.statut === "suspendue" ? "#f0fdfa" : "#fffbeb", color: annonce.statut === "suspendue" ? "#0d9488" : "#f59e0b", border: `1px solid ${annonce.statut === "suspendue" ? "#0d9488" : "#fcd34d"}`, borderRadius: "7px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>
                            {annonce.statut === "suspendue" ? "Activer" : "Suspendre"}
                          </button>
                          <button onClick={() => setConfirmDelete(annonce.id)} style={{ padding: "7px 14px", backgroundColor: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: "7px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>Supprimer</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: "70px 30px", backgroundColor: "white", borderRadius: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>
              <div style={{ width: "70px", height: "70px", borderRadius: "50%", backgroundColor: "#f0fdfa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="1.5">
                  <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
              </div>
              <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#1f2937", marginBottom: "8px" }}>Aucune annonce</h3>
              <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "24px" }}>Publiez votre première annonce pour toucher des acheteurs potentiels.</p>
              <Link to="/ajouter-annonce" style={{ display: "inline-flex", alignItems: "center", gap: "8px", backgroundColor: "#0d9488", color: "white", padding: "12px 24px", borderRadius: "10px", textDecoration: "none", fontSize: "14px", fontWeight: "600" }}>
                Publier ma première annonce
              </Link>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MesAnnonces;